import React from 'react';
import { CardHeader, Button } from '@material-ui/core';
import { Route, useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import AuthorEditor from '../../organisms/AuthorEditor';
import AuthorList from '../../organisms/AuthorList';
import ArticleEditorProps from '../../interfaces/ArticleEditorProps';
// import Revision from './Revision';
import AuthorRemove from '../../atoms/AuthorRemove';
import { useAuthentication, Role } from '../../contexts/Authentication';

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
	},
	grid: {
		display: 'flex',
		flexDirection: "column",
		height: 'calc(85vh)',
		width: 'auto'
	}
}));

const AuthorEditorHeader = () => {
	const history = useHistory();
	const { slug } = useParams<{ slug: string }>();

	return <CardHeader action={
		<>
			<Button onClick={() => {
				history.push(`/authors/edit/${slug}`);
			}}>Edit</Button>
			{/*
				<Button onClick={() => {
					history.push(`/authors/edit/${slug}/revision`);
				}}>Revision</Button>
			*/}
		</>
	} />
}

const Authors = (props: ArticleEditorProps) => {
	const history = useHistory();
	const classes = useStyles();
	const auth = useAuthentication();

	return (
		<div className={classes.container}>
			<Route exact path="/authors">
				<div className={classes.grid}>
					<AuthorList action={(e, reload) => (
						<>
							<Button onClick={() => {
								history.push(`/authors/edit/${e.slug}`)
							}}>Modifier</Button>
							{auth.role.includes(Role.Administrateur) && <AuthorRemove onRemove={reload} id={e?.id} />}
						</>)
					} />
				</div>
			</Route>
			<Route exact path="/authors/edit/:slug">
				<AuthorEditorHeader />
				<AuthorEditor type="edit" />
			</Route>
			{/*
			<Route exact path="/authors/edit/:slug/revision">
				<AuthorEditorHeader />
				<Revision />
			</Route>
			*/}
			<Route path="/authors/create">
				<AuthorEditor type="create" />
			</Route>
		</div>
	);
}

export default Authors;